const api_endpoint = process.env.NODE_ENV === 'production' ? "https://api.torgyd.com" : "http://localhost";
export default api_endpoint;